<template>
    <el-main>
        <el-select class="country-select" clearable placeholder="请选择国家"
                   v-model="country"
                   @change="countryChange">
            <el-option :key="item"
                       :label="item"
                       :value="item"
                       v-for="item in countryList">
            </el-option>
        </el-select>
        <el-cascader :options="addressLists"
                     @change="handleItemChange"
                     class="dialog-cascader"
                     v-if="country==='中国大陆'"
                     v-model="selectAddress">
        </el-cascader>
        <el-input placeholder="详细地址" v-if="country" v-model="detailAddress"/>
        <div class="div-button">
            <el-button @click="addAddress" type="primary">确定</el-button>
            <el-button @click="closeAddress">取消</el-button>
        </div>
    </el-main>
</template>

<script>
    export default {
        name: 'CityChoose',
        props: {
            addressValue: Array,
            index: Number,
            isModifyAddress: Boolean,
            addressLists: { type: Array, default: () => [] },
            cascade: { type: Number, default: 4 }
        },
        data() {
            return {
                cityList: [],
                selectAddress: [],
                countryList: ['中国大陆', '中国香港', '中国澳门', '中国台湾', '国外'],
                country: '',
                detailAddress: '',
                cityCode: ''
                // cascaderProps: {
                //     lazy: true,
                //     lazyLoad: this.getAddress
                // }
            };
        },
        watch: {
            addressValue() {
                this.setDefaultValue();
            }
        },
        async created() {
            await this.setDefaultValue();
        },
        methods: {
            /* eslint-disable */
            async setDefaultValue() {
                const self = this;
                let cityList = [];
                const address = [...this.addressValue];
                this.country = address[0];
                if (address.length > 2) {
                    address.shift();
                    this.selectAddress = address.splice(0, address.length - 1);
                }
                this.detailAddress = address[address.length - 1];
                // if (this.cascade === 4) {
                //     this.countryList = ['国内'];
                //     this.country = '国内';
                // }

            },
            handleItemChange(val) {
            },
            countryChange() {
                this.detailAddress = '';
                this.selectAddress = [];
            },
            /**
             * @Description: 添加地址
             * @author 沈先生
             * @date 2019/11/19
             */
            addAddress() {
                if (!this.country) {
                    this.$message({
                        message: '国家未选择',
                        type: 'error'
                    });
                    return;
                }
                if (!this.detailAddress) {
                    this.$message({
                        message: '详细地址未填写',
                        type: 'error'
                    });
                    return;
                }
                if (this.country === '中国大陆') {
                    this.selectAddress = this.selectAddress.map(e => e.name || e);
                    if (this.selectAddress.length < 2) {
                        this.$message({
                            message: '省/市选择不完整',
                            type: 'error'
                        });
                        return;
                    }
                }
                if (this.isModifyAddress) {
                    this.$emit('modifyAddress', {
                        country: this.country,
                        selectAddress: this.selectAddress,
                        detailAddress: this.detailAddress,
                        index: this.index
                    });
                } else {
                    this.$emit('addAddress', {
                        country: this.country,
                        selectAddress: this.selectAddress,
                        detailAddress: this.detailAddress,
                        index: this.index
                    });
                }
                this.$emit('closeAddress');
            },
            closeAddress() {
                this.$emit('closeAddress');
            }
        }
        /* eslint-enable */
    };
</script>

<style lang="scss" scoped>
    .el-main {
        padding: 0 20px;
        text-align: center;

        .country-select {
            width: 100%;
            margin-bottom: 20px;
        }

        .dialog-cascader {
            width: 100%;
            margin-bottom: 20px;
        }

        .div-button {
            width: 170px;
            margin: 20px auto;
        }
    }
</style>
